export const lightGray = '#00000045';
